import News1 from 'assets/News/news1.avif'
import News2 from 'assets/News/news2.avif'
import News3 from 'assets/News/news3.avif'
import News4 from 'assets/News/news4.avif'
import News5 from 'assets/News/news5.avif'
import News6 from 'assets/News/news6.avif'
import News7 from 'assets/News/news7.avif'

export interface NewsData {
    date: string
    title: string
    company: string,
    img: string,
    hashTag: string[]
    hashColor: string[]
}

export const newsData: NewsData[] = [
    {
        date: '2025. 02',
        title: '시스템 운영 유지보수 1년 계약 연장',
        company: '상인정보통',
        img: News1,
        hashTag: [
            '상인정보',
            '카카오톡 플랫폼',
            '영상CMS',
        ],
        hashColor: []
    },
    {
        date: '2025. 01',
        title: '소셜 미디어 웹툰 서비스 “스핀오펜“  베타오픈',
        company: '스핀오펜',
        img: News2,
        hashTag: [
            '스핀오펜',
            'SNS웹툰',
            '캐릭터디자인',
        ],
        hashColor: []
    },
    {
        date: '2025. 01',
        title: '제약바이오 산업 전문 교육플랫폼 홈페이지 개발 및 납품',
        company: '제약바이오산업',
        img: News3,
        hashTag: [
            '홈페이지',
            '제약바이오',
            'https://pharmeud.co.kr',
        ],
        hashColor: []
    },
    {
        date: '2025. 01',
        title: 'Iot 콜드체인 서비스 홈페이지 고도화',
        company: '체인익스빌',
        img: News4,
        hashTag: [
            'Iot',
            '콜드체인',
            'https://chainexpressbill.com',
        ],
        hashColor: []
    },
    {
        date: '2024. 09',
        title: 'ESP 전자낙관 솔루션 개발 납품',
        company: '아르떼',
        img: News5,
        hashTag: [
            'Electronic Signature Printer',
        ],
        hashColor: []
    },
    {
        date: '2024. 07',
        title: 'XR 융합 시제품 제작 과업',
        company: '정부과제',
        img: News6,
        hashTag: [
            'XR 디지털 운영',
            'IOT이벤트 감지',
            '데이터 통합 모델링',
        ],
        hashColor: []
    },
    {
        date: '2024. 03',
        title: 'SW 융합클러스터 2.0 사업 반도체 SW 융합 제품 상용화 지원 사업',
        company: '정부과제',
        img: News7,
        hashTag: [
            'AI 공정 예측 시스템',
            '머신러닝',
            '데이터 서버 플랫폼',
        ],
        hashColor: []
    },
]